import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { List, X, PlusCircle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/doctors", label: "Doctors" },
  { to: "/blog", label: "Health Journal" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl bg-[#F8F6F0]/80 border-b border-brand-border"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
  <img 
    src="/logo.png" 
    alt="JASHODA HOSPITAL" 
    className="h-12 w-auto object-contain"
  />
  <span className="font-serif text-xl tracking-tight text-brand-ink">JASHODA HOSPITAL</span>
</Link>

        <nav className="hidden lg:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-brand-sage" : "text-brand-ink/70 hover:text-brand-ink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Button
            data-testid="navbar-book-btn"
            onClick={() => nav("/book")}
            className="rounded-full bg-brand-sage hover:bg-brand-sageDark text-white px-6 h-11 transition-transform hover:scale-[1.03]"
          >
            Book Appointment
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className="lg:hidden p-2 text-brand-ink"
          onClick={() => setOpen((o) => !o)}
        >
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-brand-border bg-brand-bone">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `text-base font-medium ${isActive ? "text-brand-sage" : "text-brand-ink/80"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Button
              data-testid="mobile-book-btn"
              onClick={() => {
                setOpen(false);
                nav("/book");
              }}
              className="rounded-full bg-brand-sage hover:bg-brand-sageDark text-white mt-2"
            >
              Book Appointment
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
